import localStorageUtils from "./localStorage"
import { CurrencyInfo } from "./currencyInfo";

const SELECTED_CURRENCY_KEY = 'selectedCurrency';

class CurrencyStorage {
  getDefaultCurrency() {
    return new CurrencyInfo(
      window?.currencyConfig?.defaultCurrencyCode || 'USD',
      window?.currencyConfig?.defaultCurrencySymbol || '$'
    );
  }

  getSelectedCurrency() {
    try {
      const selectedCurrencyItem = localStorageUtils.getItem(SELECTED_CURRENCY_KEY);

      if (selectedCurrencyItem !== null) {
        return CurrencyInfo.fromJson(
          JSON.parse(selectedCurrencyItem)
        );
      }
    } catch (error) {
      console.error('Error getting item from localStorage', error);
    }

    return null;
  }

  setSelectedCurrency(currencyCode, currencySymbol) {
    try {
      localStorageUtils.setItem(
        SELECTED_CURRENCY_KEY,
        JSON.stringify({
          code: currencyCode,
          symbol: currencySymbol
        })
      );
    } catch (error) {
      console.error('Error setting item to localStorage', error);
    }
  }
}

export const currencyStorage = new CurrencyStorage();
